//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { filter } from 'lodash';
import { cloneDeep } from 'lodash';

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const widgetsInit = [];


export const oneStoryWithAi = (state = widgetsInit, action) => {
    switch (action.type) {
        case ActionTypes.StoryWithAi.listStoryWithAi:
            return action.payload;
        case ActionTypes.StoryWithAi.addStoryWithAi:
            return [...state, action.payload];
        case ActionTypes.StoryWithAi.deleteStoryWithAi:
            const delv = cloneDeep(state)
            const result = filter(delv, k => k.id != action.payload.id)
            return result;
        case ActionTypes.StoryWithAi.updateStoryWithAi:
            return state.map(x => { if (x.id === action.payload?.id) { return { ...x, ...action.payload }; } return x; });
        case ActionTypes.StoryWithAi.addOrUpdateAiStory:
            const isExist = state.find(x => x.id == action.payload.id)
            if (isExist) {
                return state.map(x => { if (x.id == action.payload.id) { return { ...x, ...action.payload }; } return x; });
            } else {
                return [...state, action.payload];
            }
        default:
            return state;
    }
};
export const articleLevels = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.article_level.list_article_level:
            return payload;
        case ActionTypes.article_level.create_article_level:
            return [...state, payload];
        case ActionTypes.article_level.delete_article_level:
            return state.filter(item => item.id !== payload.id);
        case ActionTypes.article_level.update_article_level:
            return state.map(x => { if (x.id === payload?.id) { return { ...x, ...payload }; } return x; });
        case ActionTypes.article_level.addOrUpdateArticleLevel:
            const isExist = state.find(x => x.id == action.payload.id)
            if (isExist) {
                return state.map(x => { if (x.id == payload.id) { return { ...x, ...payload }; } return x; });
            } else {
                return [...state, payload];
            }
        default:
            return state;
    }
};

const classStoryInit = [];


export const oneClassStory = (state = classStoryInit, action) => {
    switch (action.type) {
        case ActionTypes.StoryWithAi.createClassStory:
            return [...state, action.payload];
        default:
            return state;
    }
};